// CalendarLegend.js - Teckenförklaring för kalenderns prickar och ikoner (Spår K5)
// Används i både vecko- och dagvyn.

import React, { useState, useEffect, useRef } from 'react';
import './CalendarLegend.css';

const ITEMS = [
  { swatch: <span className="legend-lock-dot" />, text: 'Grön prick: betald eller genomförd – kan inte flyttas' },
  { swatch: <i className="fas fa-check-circle legend-paid" />, text: 'Betald' },
  { swatch: <span className="legend-card legend-noshow" />, text: 'Röd bokning: uteblivet besök' },
  { swatch: <span className="legend-cancelled"><svg viewBox="0 0 100 100" preserveAspectRatio="none"><line x1="0" y1="0" x2="100" y2="100" /><line x1="100" y1="0" x2="0" y2="100" /></svg></span>, text: 'Smal överkryssad remsa: avbokad tid' },
  { swatch: <span className="legend-group"><i className="fas fa-users" /> 4</span>, text: 'Gruppbokning (antal bokade deltagare)' },
  { swatch: <i className="fas fa-ban" />, text: 'Blockering – tiden går inte att boka' },
  { swatch: <i className="fas fa-sticky-note" />, text: 'Anteckning / admintid' },
  { swatch: <i className="fas fa-redo" />, text: 'Återkommande' },
  { swatch: <span className="legend-slot-strip" />, text: 'Färgad kant till vänster: schemaslot för en bokningstyp' },
  { swatch: <span className="legend-outside" />, text: 'Grå bakgrund: utanför arbetstid' },
  { swatch: <span className="legend-now" />, text: 'Röd linje: nu' },
  { swatch: <span className="legend-selected"><i className="fas fa-check" /></span>, text: 'Markerad bokning (klicka igen för att avmarkera)' },
  { swatch: <span className="legend-resize" />, text: 'Dra i kortets nederkant för att ändra längd' },
];

const CalendarLegend = () => {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const ref = useRef(null);

  // Fast position klampad mot fönstret - knappraden kan flöda över kanten
  // på smala skärmar, och då skulle en högerankrad ruta klippas
  const toggle = () => {
    if (!open && ref.current) {
      const r = ref.current.getBoundingClientRect();
      const width = Math.min(340, window.innerWidth - 32);
      const left = Math.max(16, Math.min(r.right - width, window.innerWidth - width - 16));
      setPos({ top: r.bottom + 6, left });
    }
    setOpen(o => !o);
  };

  // Stäng vid klick utanför eller Escape
  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className="calendar-legend" ref={ref}>
      <button
        type="button"
        className="legend-btn"
        onClick={toggle}
        title="Teckenförklaring"
        aria-expanded={open}
        aria-label="Teckenförklaring"
      >
        <i className="fas fa-info-circle"></i>
      </button>
      {open && (
        <div
          className="legend-popover"
          role="dialog"
          aria-label="Teckenförklaring"
          style={{ top: pos.top, left: pos.left }}
        >
          <div className="legend-title">Teckenförklaring</div>
          <ul>
            {ITEMS.map((item) => (
              <li key={item.text}>
                <span className="legend-swatch">{item.swatch}</span>
                <span>{item.text}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CalendarLegend;
